import React from 'react';
import styles from './LayoutSidebar.module.sass';

const LayoutSidebar = ({ children }) => {
    return <div className={styles['layoutsidebar']}>
        { children }
    </div>;
}

export default LayoutSidebar;